@let block = contact();

@if (block.styles) {
    <div [appCmsStyles]="block.styles"></div>
}
@if (block.logo?.url) {
    <cms-image
        class="footer-contact__logo"
        [media]="block.logo"
        [fallbackAlt]="'core.footer.brand-title' | translate"
    />
}
@if (block.content) {
    <div class="footer-contact__content cms-content" [innerHtml]="block.content | trustHtml"></div>
}
@for (link of block.linksList; track link.id) {
    <cms-btn class="footer-contact__link" [config]="link" />
}
